<template>
  <v-list-item v-if="!isEditing" class="it-hv">
    <abt-item-avatar :icon="'fal fa-calendar'" :note="printNote" />
    <v-list-item-content>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty">予定期間</v-list-item-subtitle>
      <v-list-item-title v-if="isPrintEmpty">予定期間</v-list-item-title>
      <v-list-item-title v-else-if="isNoAnswer">回答なし</v-list-item-title>
      <v-list-item-title v-else>
        <span v-for="(item, idx) in getTermLabelItems" :key="idx" class="caption grey lighten-2 pa-3 mr-1">{{ item }}</span>
      </v-list-item-title>
      <v-list-item-subtitle class="caption" v-if="!isPrintEmpty && !isNoAnswer">{{ printDate }}</v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn icon v-on="on" color="secondary" :loading="isThisLoading" @click="edit">
            <v-icon small>fal fa-pencil</v-icon>
          </v-btn>
        </template>
        <span>編集する</span>
      </v-tooltip>
    </v-list-item-action>
  </v-list-item>
  <v-container v-else>
    <v-subheader>予定期間</v-subheader>
    <v-row dense justify="end">
      <div class="text-xs-right">
        <v-switch color="blue darken-2" label="回答なし" v-model="config.ignore" @change="ignore"></v-switch>
      </div>
    </v-row>
    <v-row dense v-if="!isIgnore">
      <v-col cols="12" class="px-3">
        <span class="caption">期間の選択</span>
        <v-chip-group multiple column
          active-class="secondary white--text"
          v-model="form.time.content">
          <v-chip
            v-for="item in getTermItems"
            :key="`time_content_${item.value}`"
            :value="item.value"
            :rules="rules.time">{{ item.text }}</v-chip>
        </v-chip-group>
      </v-col>
      <v-col cols="12" class="px-3">
        <v-text-field
          v-model="printFormatedDate"
          maxlength="30"
          append-icon="fal fa-calendar-alt"
          @click:append="datepick"
          label="希望時期"
        />
        <v-dialog v-model="config.datepicker.date.status" max-width="290">
          <v-date-picker
            v-model="config.datepicker.date.data"
            type="month"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="datepicked"
          />
        </v-dialog>
      </v-col>
    </v-row>
    <v-row dense class="pb-4">
      <v-col cols="12" class="px-3">
        <v-text-field counter
          v-model="form.time.note"
          label="予定期間の備考欄"
          maxlength="50"
        />
      </v-col>
    </v-row>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import AbtItemAvatar from '../../../../components/avatar'
export default {
  name: 'clientAboutSurveyTime',
  components: {
    AbtItemAvatar
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        ignore: false,
        datepicker: {
          date: {
            data: '',
            status: false
          }
        }
      },
      meta: {
        time: {
          'tba': '分からない',
          '<1m': '１ヶ月未満',
          '<3m': '３ヶ月未満',
          '6m-12m': '６ヶ月〜１年未満',
          '1y>': '１年以上'
        }
      },
      form: {
        time: {
          id: '',
          content: [],
          date: '',
          note: ''
        }
      },
      rules: {
        term: [
          v => !!(v && v.length) || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function () {
      if (
        this.$props.data &&
        this.$props.data.time
      ) {
        this.$set(this.config, 'ignore', !!(this.$props.data.time.content && this.$props.data.time.content === 'NONE'))
        this.$set(this.form, 'time', {
          id: '' + (this.$props.data.time.id ? this.$props.data.time.id : 'new_time'),
          content: this.$props.data.time.content ? this.$props.data.time.content : '',
          date: this.$props.data.time.date ? this.$props.data.time.date : '',
          note: this.$props.data.time.note ? this.$props.data.time.note : ''
        })
      } else {
        this.$set(this.form, 'time', {
          id: 'new_time',
          content: '',
          date: '',
          note: ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          type: 'time'
        }
      })
    },
    datepick: function () {
      if (this.form.time.date.split('-').filter(it => isFinite(it)).length === 3) {
        this.$set(this.config.datepicker.date, 'data', this.form.time.date)
      }
      this.$set(this.config.datepicker.date, 'status', true)
    },
    datepicked: function () {
      this.$set(this.form.time, 'date', this.config.datepicker.date.data)
      this.$set(this.config.datepicker.date, 'status', false)
    },
    ignore: function () {
      this.$set(this.form.time, 'content', this.config.ignore ? 'NONE' : '')
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        ['time', 'all'].includes(this.$props.status.editing)
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.status.editing === 'time'
      )
    },
    isLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        ['time', 'all'].includes(this.$props.status.loading)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.status.loading === 'time'
      )
    },
    isIgnore () {
      return this.config.ignore
    },
    isNoAnswer () {
      return !!(
        this.$props.data &&
        this.$props.data.time &&
        this.$props.data.time.content &&
        this.$props.data.time.content === 'NONE'
      )
    },
    isPrintEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.time &&
        this.$props.data.time.content
      )
    },
    getTermLabelItems () {
      return (
        this.$props.data &&
        this.$props.data.time &&
        this.$props.data.time.content
      ) ? this.$props.data.time.content.split(',').map(it => {
        return this.meta.time[it] || it
      }) : []
    },
    printDate () {
      if (
        this.$props.data &&
        this.$props.data.time &&
        this.$props.data.time.date
      ) {
        return (
          this.$props.data.time.date.split('-').filter(it => isFinite(it)).length === 2
        ) ? (this.$moment(this.$props.data.time.date).format('YYYY年MM月') + 'ごろ') : this.$props.data.time.date
      } else {
        return ''
      }
    },
    printFormatedDate: {
      get: function () {
        if (
          this.form &&
          this.form.time &&
          this.form.time.date
        ) {
          return (
            this.form.time.date.split('-').filter(it => isFinite(it)).length === 2
          ) ? (this.$moment(this.form.time.date).format('YYYY年MM月') + 'ごろ') : this.form.time.date
        } else {
          return ''
        }
      },
      set: function (newValue) {
        this.$set(this.form.time, 'date', newValue)
      }
    },
    printNote () {
      return (
        this.$props.data &&
        this.$props.data.time &&
        this.$props.data.time.note
      ) ? this.$props.data.time.note : ''
    },
    isNoteEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.time &&
        this.$props.data.time.note
      )
    },
    getTermItems () {
      return Object.keys(this.meta.time).map(key => {
        return {
          text: this.meta.time[key],
          value: key
        }
      })
    }
  }
}
</script>
